import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getEVCBodyTypes = async (data) => {
  try {
    return await getRequest(urls.GET_EVC_BODY_TYPE, data);
  } catch (err) {
    return err;
  }
};
